import { isSupportedLocale } from '@/config/i18n/locales';
import { parseHousingDetailPath } from '@/features/pages/housing-detail/utils/parseHousingDetailPath';
import { parseProjectDetailPath } from '@/features/pages/project-detail/utils/parseProjectDetailPath';

const STATIC_FOOTER_ROUTE_SEGMENTS = new Set([
  'imprint',
  'privacy',
  'terms-and-conditions',
  'housing',
  'regions',
  'directlink',
]);

const getRouteSegmentsWithoutLocale = (pathname: string): string[] => {
  const segments = pathname.split('/').filter(Boolean);
  return segments.length > 0 && isSupportedLocale(segments[0]) ? segments.slice(1) : segments;
};

export const isHousingDetailRoute = (pathname: string): boolean =>
  parseHousingDetailPath(pathname) !== null;

export const isProjectDetailRoute = (pathname: string): boolean =>
  parseProjectDetailPath(pathname) !== null;

export const shouldShowStaticFooter = (pathname: string): boolean => {
  const segments = getRouteSegmentsWithoutLocale(pathname);
  if (segments.length === 0) return true;
  return STATIC_FOOTER_ROUTE_SEGMENTS.has(segments[0]);
};
